import { useUserStore } from '@gik/core/store/UserStore';
import type { Options } from 'ky';

export function userIdHeaderKyHook(request: Request, options: Options) {
  const { id } = useUserStore.getState();
  if (!id) return;
  request.headers.set('x-user-id', id);
}
